//sample data

const notifications = [
    {id:1, text:"Welcome to Stockmate"},
     {id:2, text:"New feature: Dashboard Analytics"},
     {id:3, text:"Welcome Back Human!!"},
     
]
export default notifications;